import { createApiEffect } from '@/features/api/common/create-api-effect'
import { ExportAssignmentQueryParams } from '@/features/api/assignment/types/types'

export const exportThemesListFx = createApiEffect<ExportAssignmentQueryParams, Blob>({
  requestMapper: (query) => ({
    method: 'GET',
    url: '/api/subject-app/themes/list/export/',
    responseType: 'blob',
    query,
  }),
})
